import styled, { css } from 'styled-components';
import { defaultTheme } from "../theme";

export const Container = /*#__PURE__*/styled.label.withConfig({ displayName: "styles__Container", componentId: "sc-xkyo64-0" })(["display:inline-flex;align-items:center;user-select:none;"]);





export const HiddenInput = /*#__PURE__*/styled.input.attrs({
  type: 'checkbox' }).withConfig({ displayName: "styles__HiddenInput", componentId: "sc-xkyo64-1" })(["opacity:0;width:0;height:0;z-index:-1;margin:0;"]);








export const Label = /*#__PURE__*/styled.span.withConfig({ displayName: "styles__Label", componentId: "sc-xkyo64-2" })(["margin-left:16px;color:", ";", ""],

(props) => props.theme.colors.Foreground,
(props) => css(props.theme.typography.SmallCapsHeadline));


Label.defaultProps = {
  theme: defaultTheme };


export const IconBox = /*#__PURE__*/styled.span.withConfig({ displayName: "styles__IconBox", componentId: "sc-xkyo64-3" })(["cursor:pointer;display:flex;align-items:center;justify-content:center;box-sizing:border-box;padding:3px;width:24px;height:24px;color:", ";border:2px solid ", ";border-radius:4px;text-align:center;flex-shrink:0;transition:border 0.2s;", " ~ &&::before{content:'';display:inline-block;color:inherit;border:5px solid;border-radius:2px;opacity:0;transition:all 0.2s;}", ":checked ~ &&::before{opacity:1;border:7px solid;color:", ";}"],








(props) => props.theme.colors['Level 2'],
(props) => props.theme.colors['Level 2'],





/* sc-selector */HiddenInput,









/* sc-selector */HiddenInput,


(props) =>
props.accentColor ? props.accentColor : props.theme.colors['Foreground']);



IconBox.defaultProps = {
  theme: defaultTheme };